import React, { useState } from "react";
import ImagePreview from "./ImagePreview";
import ConfirmDeleteModal from "src/components/ConfirmDeleteModal";

const ChildPreview = ({
  questions,
  data,
  parentQuestion,
  edit = false,
  openModal = null,
  validationErrors,
  deleteChildData = null,
  milestoneId,
}) => {
  const [isModalVisible, setModalVisible] = useState(false);
  const [currentKey, setCurrentKey] = useState(null);

  const handleDeleteClick = (key) => {
    setCurrentKey(key);
    setModalVisible(true);
  };

  const handleCloseModal = () => {
    setModalVisible(false);
  };

  const handleConfirmDelete = () => {
    deleteChildData(milestoneId, currentKey);
    setModalVisible(false);
  };
  return (
    <>
      <div>
        <h6>
          <b>{parentQuestion.label}</b>
        </h6>
        <span
          style={{
            color: "#e55353",
            fontFamily: "revert",
            fontSize: "0.875em",
          }}
        >
          {validationErrors?.[parentQuestion.id]}
        </span>
        <div
          className="table-responsive"
          style={{
            fontSize: "0.82em",
          }}
        >
          <table className="table table-striped table-bordered table-hover">
            <thead>
              <tr>
                {questions && (
                  <>
                    {parentQuestion.type == "MC" && <th>Sr. No.</th>}
                    {questions?.map((question, index) => (
                      <th
                        className={question?.type == "TA" ? `col-4` : `col-2`}
                        scope="col"
                        key={index}
                      >
                        {question.label}
                      </th>
                    ))}
                    {edit && data && <th>Actions</th>}
                  </>
                )}
              </tr>
            </thead>
            <tbody>
              {parentQuestion.type == "C" && (
                <tr>
                  {questions?.map((question, index) => (
                    <React.Fragment key={index}>
                      {question.type != "F" ? (
                        <td scope="col" key={index}>
                          {question.type === "S" ? (
                            <>
                              {question?.childOptionsVOs?.map(
                                (option, index) => (
                                  <React.Fragment key={index}>
                                    {data?.[question.id] == option.id
                                      ? option.value
                                      : ""}
                                  </React.Fragment>
                                )
                              )}
                            </>
                          ) : question.type === "ST" ? (
                            <>
                              {question?.childOptionsVOs?.map(
                                (option, index) => (
                                  <React.Fragment key={index}>
                                    {data?.[question.id] == option.id
                                      ? option.value
                                      : ""}
                                  </React.Fragment>
                                )
                              )}
                            </>
                          ) : (
                            <>{data?.[question.id]}</>
                          )}
                        </td>
                      ) : (
                        <td>
                          <ImagePreview
                            previewLabel={parentQuestion.previewLabel}
                            parentQuestion={question}
                            data={data?.[question.id]}
                            isChild={true}
                          ></ImagePreview>
                        </td>
                      )}
                    </React.Fragment>
                  ))}
                </tr>
              )}
              {data &&
                parentQuestion.type == "MC" &&
                Object.entries(data).map(([key, value], index) => (
                  <tr key={key}>
                    <td>{index+1}</td>
                    {questions.map((question, index) => (
                      <React.Fragment key={index}>
                        {question.type != "F" ? (
                          <>
                            <td scope="col" key={index}>
                              {question.type === "S" || question.type === "ST" ? (
                                <>
                                  {question?.childOptionsVOs?.map(
                                    (option, index) => (
                                      <React.Fragment key={index}>
                                        {value[question.id] == option.id
                                          ? option.value
                                          : ""}
                                      </React.Fragment>
                                    )
                                  )}
                                </>
                              ) : (
                                <>{value[question.id]}</>
                              )}
                            </td>
                          </>
                        ) : (
                          <td>
                            <ImagePreview
                              previewLabel={parentQuestion.previewLabel}
                              parentQuestion={question}
                              data={value[question.id]}
                              isChild={true}
                            ></ImagePreview>
                          </td>
                        )}
                      </React.Fragment>
                    ))}
                    {edit && (
                      <td>
                        <div className="d-flex flex-wrap">
                          <button
                            type="button"
                            className="btn btn-sm btn-primary m-1"
                            onClick={(e) => openModal(e, parentQuestion, key)}
                          >
                            Edit
                          </button>
                          <button
                            type="button"
                            className="btn btn-sm btn-primary m-1"
                            onClick={() => handleDeleteClick(key)}
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    )}
                  </tr>
                ))}
              {!data && (
                <tr>
                  <td
                    colSpan={questions?.length + 1}
                    style={{
                      textAlign: "center",
                    }}
                  >
                    No Data uploaded!
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <ConfirmDeleteModal
        isVisible={isModalVisible}
        onClose={handleCloseModal}
        handleConfirm={handleConfirmDelete}
      />
    </>
  );
};

export default ChildPreview;
